import { createClient } from "@supabase/supabase-js";
import { getEnvValue } from "./safeEnv";

// Use safeEnv helper for environment variable access
const url = getEnvValue('VITE_SUPABASE_URL') ?? import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const anon = getEnvValue('VITE_SUPABASE_ANON_KEY') ?? import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

let client: ReturnType<typeof createClient> | undefined;
if (url && anon) {
  client = createClient(url, anon);
} else {
  // Allow marketing site to load without Supabase envs
  console.warn("Supabase env not set; running in marketing-only mode");
}

export const supabase = (client ?? ({} as any));


